import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';

import slider1 from '../../assests/sliderImages/banner5.png';
import slider2 from '../../assests/SJImg.jpg';
import slider3 from '../../assests/sliderImages/banner6.jpg';

import { ChevronLeft, ChevronRight } from 'lucide-react';

const ImageSlider = () => {
  const images = [slider1, slider2, slider3];

  return (
    <div className="relative w-full py-6 flex justify-center">
      <div className="relative w-full max-w-[200vh]">
        <Swiper
          modules={[Navigation, Autoplay]}
          autoplay={{ delay: 4000, disableOnInteraction: false }}
          loop={true}
          navigation={{
            nextEl: '.swiper-button-next-custom',
            prevEl: '.swiper-button-prev-custom',
          }}
          className="rounded-xl"
        >
          {images.map((img, index) => (
            <SwiperSlide key={index}>
              {/* Relative container for the image and absolute content */}
              <div className="relative w-full h-[180px] sm:h-[250px] md:h-[350px] lg:h-[400px]">
  <img
    src={img}
    alt={`slider-${index}`}
    className="w-full h-full object-cover rounded-xl"
  />

                {/* === CONTENT FOR THE THIRD SLIDE (index 2) === */}
                {index === 2 && (
                  <div className="absolute inset-0 flex items-center justify-end p-8 md:p-16 bg-black/20 rounded-xl">
                    <div className="text-right text-white max-w-lg">
                      <h2 className="text-lg sm:text-2xl md:text-5xl font-extrabold font-[Cinzel] mb-2 md:mb-3 leading-tight text-white drop-shadow-lg">
                        Unveil Our Exclusive Collection
                      </h2>
                     <p className="text-xs sm:text-sm md:text-xl font-medium mb-4 md:mb-6 drop-shadow-md">
                        Discover limited-edition designs and timeless elegance. Find your next masterpiece.
                      </p>
                      <a
  href="/collections"
  className="px-6 py-3 text-lg font-semibold bg-amber-600 text-white rounded-lg shadow-xl hover:bg-amber-700 transition duration-300 inline-block"
>
  Shop All Jewellery
</a>

                    </div>
                  </div>
                )}
                {/* ============================================== */}

              </div>
            </SwiperSlide>
          ))}
        </Swiper>

       {/* Custom Arrows */}
<div className="swiper-button-prev-custom absolute left-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 text-black p-2.5 rounded-full shadow hover:bg-white transition duration-300">
  <ChevronLeft size={20} />
</div>
<div className="swiper-button-next-custom absolute right-4 top-1/2 -translate-y-1/2 z-20 bg-white/80 text-black p-2.5 rounded-full shadow hover:bg-white transition duration-300">
  <ChevronRight size={20} />
</div>

      </div>
    </div>
  );
};

export default ImageSlider;